import React, { useEffect, useState, useRef } from 'react'
import { Dialog, DialogContent, DialogContentText, DialogTitle, Grid, Button, Link } from '@mui/material';
import colors from '../../colors';
import { texts } from '../texts';
import { useDispatch, useSelector } from 'react-redux';
import { closeScaDialog, selectUtilityState, setIsScaCompleted, setPin } from '../../../features/utilities/utilitySlice';
import QRCode from 'react-qr-code';
import { selectGlobalDataState } from '../../../features/global/globalDataSlice';
import { sendGeneralRequest } from '../../../features/generalRequest';
import { Buffer } from 'buffer';
import OtpInput from 'react-otp-input';

export const ScaDialog = (props) => {
    const isOpen = props.isConfirmationDialogOpen
    const utilitySliceState = useSelector(selectUtilityState)
    const dispatch = useDispatch()
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const [PIN, setPIN] = useState('')
    const [displayQR, setDisplayQR] = useState(false)
    const [isDisabled, setIsDisabled] = useState(true)
    const transID = utilitySliceState.startTransactionResponse.transID || utilitySliceState.startTransactionResponse.trxID
    const totalValue = utilitySliceState.startTransactionResponse.totalValue
    const nonce = utilitySliceState.startTransactionResponse.nonce
    const qrString = `${transID}@${totalValue}@${nonce}`;
    const qrBase64 = Buffer.from(qrString).toString('base64');
    const otpInputRef = useRef(null);

    useEffect(() => {
        if (isOpen && otpInputRef.current) {
            setTimeout(() => {
                otpInputRef.current.focus();
            }, 100);
        }
    }, [isOpen]);

    const handlePinChange = (pinValue) => {
        setPIN(pinValue)
    }

    useEffect(() => {
        if (PIN.length === 6) {
            setIsDisabled(false)
        } else {
            setIsDisabled(true)
        }
        if (displayQR) {
            setIsDisabled(true)
        }

    }, [PIN, displayQR])

    useEffect(() => {
        let interval;

        if (displayQR) {
            const firstTimeout = setTimeout(() => {
                interval = setInterval(() => {
                    confirmSca();
                }, 3000);
            }, 3000);

            return () => {
                clearTimeout(firstTimeout);
                clearInterval(interval);
            };
        }

        return () => clearInterval(interval);
    }, [displayQR]);

    const checkPin = () => {
        dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, passkey: PIN, passkeyType: 1 }, baseUrlKey: 'services', endpoint: 'ValidateSecondFactor' })).then(response => {
            if (response.payload.response.success) {
                dispatch(setPin(PIN)) //e ben set te utility slice
                setDisplayQR(true)
            }
        })
    }

    const confirmSca = () => {
        dispatch(sendGeneralRequest({ request: { token: globalDataSliceState.token, transID: utilitySliceState.startTransactionResponse.transID || utilitySliceState.startTransactionResponse.trxID }, baseUrlKey: 'services', endpoint: 'IsChallengePassed' })).then(response => {
            if (response.payload.response.success) {
                setIsDisabled(false)
            }
        })
    }

    const handleCloseDialog = (event, reason) => {
        if (reason !== "backdropClick") {
            setPIN('');
            setDisplayQR(false);
            props.handleClose(false);

        }
    };

    const handleConfirm = () => {
        setPIN('');
        setDisplayQR(false);
        props.handleClose(true);
        dispatch(closeScaDialog())
        dispatch(setIsScaCompleted(true))
    }


    return (
        <>
            <Grid>
                <Dialog
                    open={isOpen}
                    onClose={handleCloseDialog}
                    disableEscapeKeyDown={true}
                    keepMounted
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    PaperProps={{
                        style: {
                            borderRadius: '20px',
                            width: '90%',
                            maxWidth: '500px',
                            zIndex: 9999,
                        },
                    }}
                    sx={{ zIndex: 9999 }}
                >
                    <DialogTitle id="scroll-dialog-title" sx={{ textAlign: 'center', background: colors.gradientOrange, color: colors.white, fontSize: '1.1rem', fontFamily: 'GerberaBold' }} >Autorizim per kryerjen e veprimit</DialogTitle>
                    {displayQR && (
                        <DialogContent>
                            <DialogContentText
                                id="scroll-dialog-description"
                                pt={'4%'}
                                sx={{ fontSize: '0.8rem', color: colors.darkBlue, textAlign: 'center', fontFamily: "GerberaLight" }}
                            >
                                {texts['message-sca-procedure']}
                            </DialogContentText>
                        </DialogContent>
                    )}
                    <Grid container item md={12} xs={12} mt={1} spacing={2} direction="column" alignItems="center">
                        {!displayQR ? (
                            <Grid container item md={12} xs={12} spacing={2} alignItems="center" justifyContent="center" direction="column">
                                <span style={{ fontSize: '0.9rem', fontWeight: 500, color: colors.darkBlue, textAlign: 'center', margin: '20px 0' }}>
                                    {texts['prompt-pin-input']}
                                </span>
                                <Grid item md={5} xs={12} justifyContent="center" marginLeft='30px' marginBottom='20px'>
                                    <OtpInput
                                        value={PIN}
                                        onChange={handlePinChange}
                                        numInputs={6}
                                        isInputNum
                                        inputStyle={{
                                            width: '2rem',
                                            height: '2.5rem',
                                            outline: 'none',
                                            border: 'none',
                                            borderBottom: '1px solid gray',
                                            fontFamily: 'GerberaLight',
                                            color: colors.darkBlue,
                                            fontSize: '1.2rem',
                                            paddingBottom: '3%',
                                            height: '60%',
                                            textAlign: 'center',
                                            marginRight: '0.5rem',
                                        }}
                                        renderInput={(props) => <input {...props} type="password" />}
                                    />
                                </Grid>
                            </Grid>
                        ) : (
                            <Grid item md={5} xs={12} marginLeft={14} justifyContent='center'>
                                <QRCode style={{ height: "auto", maxWidth: "60%", width: "100%" }} value={qrBase64} />
                            </Grid>
                        )}
                    </Grid>
                    <Grid container direction={'column'} pb={'3%'} >
                        <Grid container item md={12} justifyContent={'center'} pb={'1.5%'} pt={'8%'}>
                            <Button onClick={() => (displayQR ? handleConfirm() : checkPin())} disabled={isDisabled} sx={{ color: colors.white, background: colors.gradientOrange, fontFamily: 'GerberaBold', textTransform: 'none' }} >{texts["button-confirm"]}</Button>
                        </Grid>
                        <Grid container item md={12} justifyContent={'center'} >
                            <Link component='button' onClick={handleCloseDialog} sx={{ color: colors.darkBlue, fontFamily: 'GerberaLight' }} >{texts["button-cancel"]}</Link>
                        </Grid>
                    </Grid>
                </Dialog>
            </Grid>
        </>)
}
export default ScaDialog